(() => {
  function mount(container) {
    const template = container.querySelector("template[data-rk-follow-template]");
    if (!template || container.dataset.rkFollowLoaded) return;
    container.dataset.rkFollowLoaded = "true";
    const content = template.content.cloneNode(true);
    const scripts = [...content.querySelectorAll("script")];
    scripts.forEach(script => script.remove());
    container.appendChild(content);
    scripts.forEach(original => {
      const script = document.createElement("script");
      [...original.attributes].forEach(attribute => script.setAttribute(attribute.name, attribute.value));
      script.textContent = original.textContent;
      container.appendChild(script);
    });
    template.remove();
  }
  const containers = document.querySelectorAll("[data-rk-deferred-follow]");
  if (!("IntersectionObserver" in window)) {
    containers.forEach(mount);
    return;
  }
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      observer.unobserve(entry.target);
      mount(entry.target);
    });
  }, {rootMargin: "300px"});
  containers.forEach(container => observer.observe(container));
})();
